export default __webpack_public_path__ + "static/media/MaksymB352.420a0bdf.jpg";